<template>
    <div style="width: 90%; margin: auto; display: block;">
        <b-card>
            <b-card-text>
                <h4>Add Groups</h4>
                <b-alert variant="primary" show><sub>Use this tool to add product groups to the system. Please ensure the SKU for each product group is unique and without spaces and quotes (like "'", etc.)</sub></b-alert>
            </b-card-text>
        </b-card>

        <div style="margin-top: 5px; padding: 5px;">
            <loading :active="items_being_submitted"
                :can-cancel="false"
                :is-full-page="true">
            </loading>

            <b-card-text style="text-align: right; ">
                <b-button size="sm" variant="success" @click="add_new" v-if="items.length == 0">ADD NEW</b-button>
                <b-button v-else size="sm" variant="danger" @click="reset">RESET</b-button>
            </b-card-text>

            <b-card v-for="item,idx in items" style="margin-bottom: 10px; border: 1px solid;" v-bind:key="idx">
                <b-card header="GROUP INFORMATION" style="margin-bottom: 10px;">
                    <div style="display: inline-block;">
                        <b-card-text class="caption">SKU</b-card-text>
                        <b-input v-model="item.product_sku" size="sm" style="width: 220px; font-size: 14px; font-weight: bold;"></b-input>
                    </div>
                    <div style="display: inline-block;">
                        <b-card-text class="caption">DESCRIPTION</b-card-text>
                        <b-input v-model="item.product_name" size="sm" style="width: 220px; font-size: 14px;"></b-input>
                    </div>

                    <div style="display: inline-block;">
                        <b-card-text class="caption">CATEGORY</b-card-text>
                        <b-form-select 
                            v-model="item.category_id" 
                            :options="categories" 
                            size="sm" 
                            style="width: 150px; font-size: 14px;"
                            @change="loadSubcategories(item)">
                        </b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <b-card-text class="caption">SUBCATEGORY</b-card-text>
                        <b-form-select 
                            v-model="item.subcategory_id" 
                            :options="item.subcategoryOptions || []" 
                            size="sm" 
                            style="width: 150px; font-size: 14px;"
                            :disabled="!item.category_id">
                        </b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <b-card-text class="caption">VENDOR</b-card-text>
                        <b-form-select v-model="item.vendor_id" :options="vendors" size="sm" style="width: 170px; font-size: 14px;"></b-form-select>
                    </div>

                    <div style="display: inline-block;">
                        <b-card-text class="caption">SELL PRICE</b-card-text>
                        <b-input :value="(sum_children_cost() || 0.0).toFixed(2)" size="sm" style="width: 80px; font-size: 14px; background: #c1ffc1; text-align: center;" :disabled="true"></b-input>
                    </div>
                    <div style="display: inline-block;">
                        <b-card-text class="caption">LANDED CST</b-card-text>
                        <b-input :value="(sum_children_landed_cost() || 0.0).toFixed(2)" size="sm" style="width: 80px; font-size: 14px; background: #c1ffc1; text-align: center;" :disabled="true"></b-input>
                    </div>
                    <div style="display: inline-block;">
                        <b-card-text class="caption">WHLSL PRICE</b-card-text>
                        <b-input :value="(sum_children_wholesale_price() || 0.0).toFixed(2)"  size="sm" style="width: 80px; font-size: 14px; background: #c1ffc1; text-align: center;" :disabled="true"></b-input>
                    </div>
                    <div style="display: inline-block;">
                        <div style="font-size: 10px; color: #666; text-align: center;">
                            Child sum: {{(sum_children_fob_price() || 0.0).toFixed(2)}}
                        </div>
                        <b-card-text class="caption">FOB TOTAL</b-card-text>
                        <b-input 
                            v-model="item.fob_price_total"
                            type="number"
                            step="0.01"
                            size="sm" 
                            style="width: 80px; font-size: 14px; background: #fffacd; text-align: center;" 
                            @input="updateGroupFobPrice(item, $event)"
                            >
                        </b-input>
                        
                    </div>
                    <div style="display: inline-block;">
                        <b-card-text class="caption">CUBES</b-card-text>
                        <b-input :value="(sum_children_cubes() || 0.0).toFixed(2)" size="sm" style="width: 80px; font-size: 14px; background: #c1ffc1; text-align: center;" :disabled="true"></b-input>
                    </div>
                    <div style="display: inline-block;">
                        <b-card-text class="caption">SPIFF</b-card-text>
                        <b-input v-model="item.spiff" type="number" size="sm" style="width: 80px; font-size: 14px; text-align: center;"></b-input>
                    </div>
                   <div style="display: inline-block; vertical-align: top; margin-left: 10px;">
                        <b-card-text class="caption">IS BOXES</b-card-text>
                        <div style="text-align: center;">
                            <b-form-checkbox
                                v-model="item.is_box"
                                size="sm"
                                style="margin-top: 5px; transform: scale(1.5); width:50px;"
                                switch
                            >
                            </b-form-checkbox>
                        </div>
                    </div>
                </b-card>

                <b-card header="CHILDREN">
                    <div style="overflow-x: auto;">
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <th class="srr" style="min-width: 150px;">PRODUCT SKU</th>
                                    <th class="srr" style="min-width: 200px;">PRODUCT NAME</th>
                                    <th class="srr" style="min-width: 70px;">ORIG PRICE</th>
                                    <th class="srr" style="min-width: 70px;">FOB PRICE</th>
                                    <th class="srr" style="min-width: 70px;">GRP UNIT PRICE</th>
                                    <th class="srr" style="min-width: 70px;">QTY</th>
                                    <th class="srr" style="min-width: 70px;">ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="child, cidx in item.children" v-bind:key="cidx">
                                    <td class="srrv">{{child.product_sku}}</td>
                                    <td class="srrv">{{child.product_name}}</td>
                                    <td class="srrv">{{child.selling_price}}</td>
                                    <td class="srrv">
                                        <b-input 
                                            size="sm" 
                                            style="text-align: center; background: #fffacd;" 
                                            type="number" 
                                            step="0.01"
                                            v-model="child.fob_price"
                                            @change="updateChildFobPrice(child, $event)">
                                        </b-input>
                                    </td>
                                    <td class="srrv"><b-input size="sm" style="text-align: center; background: lightyellow;" type="number" v-model="child.unit_selling_price"></b-input></td>
                                    <td class="srrv"><b-input size="sm" style="text-align: center; background: lightyellow;" type="number" v-model="child.quantity"></b-input></td>
                                    <td class="srrv"><b-button size="sm" variant="danger" style="font-size: 12px;" @click="remove_child(item, child)">REMOVE</b-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div style="margin-top: 10px;">
                        <vue-simple-suggest
                            v-model="keyword"
                            display-attribute="product_name"
                            value-attribute="product_id_product_sku"
                            :list="searchProducts"
                            :filter-by-query="false"
                            @select="add_to_cache"
                            :min-length="2"
                            ref="product"
                            style="margin-bottom: 10px; font-size: 14px; font-family: monospace; width: 100%; border: 1px solid black;"
                            class="input-field"
                            placeholder="type in product names to get recommendations"
                        >
                            <div slot="suggestion-item" slot-scope="{ suggestion, autocomplete }" :style="{'background-color': exists_bg(suggestion), 'color': exists_color(suggestion)}">
                                <span>
                                    {{ suggestion.product_name }} [{{suggestion.product_sku}}]
                                </span>
                            </div>
                        </vue-simple-suggest>
                    </div>
                </b-card>

                <b-alert show variant="transparent" style="text-align: right;">
                    <b-button size="sm" variant="primary" @click="submit_single(item)">SUBMIT</b-button>
                </b-alert>
            </b-card>
        </div>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import VueSimpleSuggest from 'vue-simple-suggest'
    import 'vue-simple-suggest/dist/styles.css' // Optional CSS

    export default {
        name: "AddProducts",
        components: {Backer, flatPickr, Loading, VueSimpleSuggest},
        data: function() {
            return {
                packet: {},
                items: [],
                items_being_submitted: false,
                vendors: [],
                categories: [],
                idx: 0,
                items_being_loaded: false,
                products: [],
                subcategories: {},
                keyword: '',
                quantities: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ]
            }
        },
        methods: {
            loadAllSubcategories: function() {
                let that = this;
                let path = "/api/product/get_subcategories/";
                let data = {};
                
                let s = function(response) {
                    console.log("API Response for all subcategories:", response.data);
                    
                    if (response.data.error) {
                        console.error("Error loading all subcategories:", response.data.error);
                        return;
                    }
                    
                    // Group subcategories by category_id
                    const grouped = {};
                    
                    if (response.data.result && Array.isArray(response.data.result)) {
                        response.data.result.forEach(subcat => {
                            const catId = subcat.category_id;
                            if (!grouped[catId]) {
                                grouped[catId] = [];
                            }
                            grouped[catId].push({
                                value: subcat.id,
                                text: subcat.subcategory
                            });
                        });
                    }
                    
                    console.log("Grouped subcategories:", grouped);
                    
                    // Store in cache
                    that.subcategories = grouped;
                    
                    // Update existing items if they have a category selected
                    that.items.forEach(item => {
                        if (item.category_id) {
                            that.loadSubcategories(item);
                        }
                    });
                }
                
                let f = function(error) {
                    console.error("Failed to load all subcategories:", error);
                }
                
                Requestor.postSync(path, data, s, f);
            },
            
            loadSubcategories: function(item) {
                console.log("loadSubcategories called for item:", item);
                console.log("item.category_id:", item.category_id);
                
                const categoryId = item.category_id;
                
                // Reset subcategory when category changes
                item.subcategory_id = null;
                
                if (!categoryId) {
                    console.log("No category ID, clearing options");
                    item.subcategoryOptions = [];
                    return;
                }
                
                // Get from cache or use empty array
                const cached = this.subcategories[categoryId] || [];
                console.log("Cached subcategories for category", categoryId, ":", cached);
                
                // Format options
                const options = [...cached];
                options.unshift({
                    value: null,
                    text: "Select Subcategory (Optional)"
                });
                
                console.log("Final options:", options);
                item.subcategoryOptions = options;
                
                // Force Vue to react to the change
                this.$nextTick(() => {
                    console.log("After setting subcategoryOptions:", item.subcategoryOptions);
                });
            },
            
            sum_children_fob_price: function(){
                let output = 0.0;
                if (this.items.length > 0 && this.items[0].children) {
                    for (var i = 0; i < this.items[0].children.length; i++){
                        let fobPrice = parseFloat(this.items[0].children[i].fob_price) || 0;
                        let quantity = parseInt(this.items[0].children[i].quantity) || 0;
                        output += fobPrice * quantity;
                    }
                }
                return output;
            },
            
            updateGroupFobPrice: function(item, value) {
                // Ensure the value is a valid number
                let newValue = parseFloat(value);
                if (!isNaN(newValue) && newValue >= 0) {
                    item.fob_price_total = newValue;
                } else {
                    item.fob_price_total = 0.0;
                }
                
                // Update the display
                this.$forceUpdate();
            },
            
            updateChildFobPrice: function(child, event) {
                // Ensure the value is a valid number
                let newValue = parseFloat(event.target.value);
                if (!isNaN(newValue) && newValue >= 0) {
                    child.fob_price = newValue;
                } else {
                    child.fob_price = 0.0;
                }
                
                // Update the total display
                this.$forceUpdate();
            },
            
            searchProducts: async function(query) {
                if (!query || query.length < 2) {
                    return []; // Don't search for very short queries
                }

                let data = { search: query };
                let path = "/api/product/search_products_all/";
                let that = this;

                try {
                    let response = await Requestor.getAsync(path, data);
                    if (response.data.error) {
                        console.error("Error searching products:", response.data.error);
                        return [];
                    }
                    return response.data.result;
                } catch (error) {
                    console.error("Error searching products:", error);
                    return [];
                }
            },
            
            sum_children_cubes: function(){
                let output = 0.0;
                if (this.items.length > 0 && this.items[0].children) {
                    for (var i=0; i<this.items[0].children.length; i++){
                        output += (this.items[0].children[i].cubes || 0) * (this.items[0].children[i].quantity || 0);
                    }
                }
                return output;
            },
            
            sum_children_landed_cost: function(){
                let output = 0.0;
                if (this.items.length > 0 && this.items[0].children) {
                    for (var i=0; i<this.items[0].children.length; i++){
                        output += (this.items[0].children[i].landed_cost || 0) * (this.items[0].children[i].quantity || 0);
                    }
                }
                return output;
            },
            
            sum_children_wholesale_price: function(){
                let output = 0.0;
                if (this.items.length > 0 && this.items[0].children) {
                    for (var i=0; i<this.items[0].children.length; i++){
                        output += (this.items[0].children[i].wholesale_price || 0) * (this.items[0].children[i].quantity || 0);
                    }
                }
                return output;
            },
            
            sum_children_cost: function(){
                let output = 0.0;
                if (this.items.length > 0 && this.items[0].children) {
                    for (var i=0; i<this.items[0].children.length; i++){
                        output += (this.items[0].children[i].unit_selling_price || 0) * (this.items[0].children[i].quantity || 0);
                    }
                }
                return output;
            },
            
            exists_bg: function(suggestion){
                if (this.items.length > 0 && this.items[0].children && 
                    this.items[0].children.filter(function(d){return d.product_sku == suggestion.product_sku}).length > 0){
                    return '#ffeb3b';
                }
                else {
                    return '#efefef';
                }
            },
            
            exists_color: function(suggestion){
                if (this.items.length > 0 && this.items[0].children && 
                    this.items[0].children.filter(function(d){return d.product_sku == suggestion.product_sku}).length > 0){
                    return 'black';
                }
                else {
                    return 'black';
                }
            },
            
            reset: function(){
                this.items = [];
                this.keyword = '';
                this.idx = 0;
            },
            
            check_errors_single: function(item){
                let errors = [];
                if (!item.product_sku || item.product_sku.includes(" ")){
                    errors.push("Group sku cannot be empty or cannot have spaces. Please check.");
                    item.added_to_db = 'NO';
                }

                if (!item.product_name){
                    errors.push("Group name or description cannot be empty.");
                    item.added_to_db = 'NO';
                }

                if (!item.category_id || !item.vendor_id){
                    errors.push("Group's category/vendor cannot be empty.");
                    item.added_to_db = 'NO';
                }

                if (!item.selling_price || isNaN(parseFloat(item.selling_price)) ){
                    errors.push("Group should have valid selling price.");
                    item.added_to_db = 'NO';
                }

                if (!item.cubes || isNaN(parseFloat(item.cubes)) ){
                    errors.push("Group should have valid cube size.");
                    item.added_to_db = 'NO';
                }

                if (!item.spiff || isNaN(parseFloat(item.spiff)) ){
                    errors.push("Group should have valid spiff value.");
                    item.added_to_db = 'NO';
                }

                // Add validation for FOB price
                if (item.fob_price_total === undefined || item.fob_price_total === null || isNaN(parseFloat(item.fob_price_total))){
                    errors.push("Group should have a valid FOB price.");
                    item.added_to_db = 'NO';
                }

                if (item.children.length == 0){
                    errors.push("A group should have at least one child.");
                    item.added_to_db = 'NO';
                }

                for (var i=0; i<item.children.length; i++){
                    let child = item.children[i];
                    if (!child.unit_selling_price || isNaN(parseFloat(child.unit_selling_price))){
                        errors.push("All children should have valid unit selling price.");
                        item.added_to_db = 'NO';
                    }
                    // Validate FOB price for children (optional, can be 0)
                    if (child.fob_price === undefined || child.fob_price === null || isNaN(parseFloat(child.fob_price))){
                        child.fob_price = 0.0; // Set default if invalid
                    }
                }

                return errors;
            },
            
            submit_single: function(item){
                let data = this.items[0];

                data.product_sku = data.product_sku.replaceAll(/\s/g, "");
                data.children = data.children.map(function(d){
                    d.product_sku = d.product_sku.replaceAll(/\s/g, "");
                    d.unit_selling_price = +d.unit_selling_price;
                    d.fob_price = +(d.fob_price || 0.0);
                    return d;
                });
                data.selling_price = this.sum_children_cost();
                data.wholesale_price = this.sum_children_wholesale_price();
                data.landed_cost = this.sum_children_landed_cost();
                data.cubes = this.sum_children_cubes();
                // Use the editable fob_price_total from the form
                data.fob_price_total = +data.fob_price_total;
                data.is_box = item.is_box;

                let errors = this.check_errors_single(data);

                if (errors.length > 0) {
                    this.$vex.dialog.alert({
                        message: errors[0]
                    });
                    return;
                }

                let that = this;
                let path = "/api/product/add_single_group/";

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully added the group to system.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items = [];
                    }
                    that.items_being_submitted = false;
                };

                let f =  function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error adding the group. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_submitted = false;
                };
                this.items_being_submitted = true;
                Requestor.postSync(path, data, s, f);
            },
            
            remove_child: function(item, child){
                if (!item.children) return;
                
                item.children = item.children.filter(function(d){
                    return d.idx != child.idx;
                });

                // Update all totals after removal
                this.update();
            },
            
            add_new: function(){
                let item = {
                    idx: this.idx,
                    product_sku: null,
                    product_name: null,
                    category_id: null,
                    subcategory_id: null,
                    vendor_id: null,
                    landed_cost: null,
                    selling_price: 0.0,
                    wholesale_price: null,
                    fob_price_total: 0.0, // Make editable
                    cubes: null,
                    added_to_db: null,
                    errors: null,
                    children: [],
                    spiff: 0.0,
                    is_box: false,
                    subcategoryOptions: [],
                };
                this.items.splice(0, 0, item);
                this.idx += 1;
            },
            
            fetch_init: function(){
                let data = {};
                let path = "/api/product/get_product_list_v4/";
                let that = this;
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            "ERROR RETRIEVING PRODUCT LIST",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.products = response.data.result;
                    }
                    that.items_being_loaded = false;
                };

                let f = function(error) {
                    that.$bvToast.toast(
                        "Error retrieving products.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                };

                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            add_to_cache: function(e) {
                if (this.items.length === 0) {
                    this.add_new();
                }
                
                let existing_skus = this.items[0].children.map(function(d){return d.product_sku});

                if (existing_skus.includes(e.product_sku)){
                    this.$vex.dialog.alert({
                        message: "SKU "+e.product_sku+" already exists in children."
                    });
                    return;
                }

                let idx = this.items[0].children.length;
                this.items[0].children.push({
                    product_id: e.product_id,
                    product_name: e.product_name,
                    product_sku: e.product_sku,
                    unit_selling_price: e.unit_selling_price,
                    selling_price: e.selling_price,
                    fob_price: e.fob_price || 0.0,
                    quantity: 1,
                    cubes: (e.cubes || 0.0),
                    wholesale_price: (e.wholesale_price || 0.0),
                    landed_cost: (e.landed_cost || 0.0),
                    idx: idx,
                });

                // Update totals
                this.update();

                this.$nextTick(() => {
                    if (this.$refs.product && this.$refs.product.length > 0) {
                        this.$refs.product[0].setText(this.keyword);
                    }
                    this.keyword = '';
                });
            },
            
            update: function(){
                for (var i=0; i<this.items.length; i++){
                    let children = this.items[i].children;
                    this.items[i].cubes = 0.0;
                    this.items[i].wholesale_price = 0.0;
                    this.items[i].landed_cost = 0.0;
                    // Note: fob_price_total is now editable, so we don't auto-calculate it here
                    // We only show the sum of children FOB prices for reference
                    for (var j=0; j<children.length; j++){
                        let cubes = (children[j].cubes || 0.0);
                        let wholesale_price = (children[j].wholesale_price || 0.0);
                        let landed_cost = (children[j].landed_cost || 0.0);

                        let quantity = children[j].quantity || 0;
                        this.items[i].cubes += cubes * quantity;
                        this.items[i].wholesale_price += wholesale_price * quantity;
                        this.items[i].landed_cost += landed_cost * quantity;
                    }
                }
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.vendors = this.packet.vendors;
            this.categories = this.packet.categories;
            this.fetch_init();
            this.loadAllSubcategories();
        }
    }
</script>

<style scoped>
    .caption {
        margin-bottom: 3px; font-size: 12px; font-weight: bold;
    }

    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
        font-size: 11px;
        background: silver;
    }
    .ipt_tdr {
        font-weight: normal;
        font-size: 11px;
        background: aliceblue;
    }

    .vue-simple-suggest.designed .suggestions .suggest-item.selected {
        background-color: white !important;
        color: black !important;
    }

    .vue-simple-suggest.designed .suggestions .suggest-item.hover {
        background-color: white !important;
        color: black !important;
        font-weight: bold !important;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        background: #ffeaa7;
        border: 1px solid #010101;
        font-weight: bold;
    }

    .srrv {
        font-size: 12px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Products/AddGroup.vue